/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsnoname2Inputs */

const en_ticketsnoname2 = /** @type {(inputs: Ticketsnoname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No name`)
};

const de_ticketsnoname2 = /** @type {(inputs: Ticketsnoname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Namen`)
};

/**
* | output |
* | --- |
* | "No name" |
*
* @param {Ticketsnoname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsnoname2 = /** @type {((inputs?: Ticketsnoname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsnoname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsnoname2(inputs)
	return de_ticketsnoname2(inputs)
});
export { ticketsnoname2 as "ticketsNoName" }